'use client';

import { TEXT_VARIANT } from '@pixum/text';
import { DIALOG_ROLES, RichTextWithDialogs } from 'components';
import { trackLegalDialogOpen } from '../../analytics/checkout';
import type { LegalTextProps } from '../types';
import { DataPrivacyCheckbox } from './DataPrivacyCheckbox';
import styles from './LegalText.module.css';

/** "By ordering you accept…" notice. Its `openDialog` markers open the matching Contentful section in a dialog. */
export function LegalText({
  sentence,
  dialogs,
  closeLabel,
  dialogFullScreen,
  center = false,
  errorText,
  isDataPrivacyRequired = false
}: LegalTextProps) {
  if (isDataPrivacyRequired) {
    return (
      <DataPrivacyCheckbox
        sentence={sentence}
        dialogs={dialogs}
        closeLabel={closeLabel}
        dialogFullScreen={dialogFullScreen}
        center={center}
        errorText={errorText}
      />
    );
  }

  return (
    <RichTextWithDialogs
      sentence={sentence}
      dialogs={dialogs}
      variant={TEXT_VARIANT.FOOTNOTE}
      center={center}
      className={styles['legalText']}
      dialogRole={DIALOG_ROLES.ALERT}
      dialogFullScreen={dialogFullScreen}
      closeLabel={closeLabel}
      onDialogOpen={trackLegalDialogOpen}
    />
  );
}
